/* eslint-disable @typescript-eslint/no-explicit-any */
import { addStyleByPredicate } from "../../helpers/helpers";
export var addStyleByPredicateWithProps = function addStyleByPredicateWithProps(predicate, style) {
  return addStyleByPredicate(predicate)(style);
};
export var addHoverStyle = addStyleByPredicate(function (_ref) {
  var disabled = _ref.disabled,
      isLoading = _ref.isLoading;
  return !(disabled || isLoading);
});
export var addDisabledStyle = addStyleByPredicate(function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled;
});
export var addLoadingStyle = addStyleByPredicate(function (_ref3) {
  var isLoading = _ref3.isLoading;
  return isLoading;
});